import AuditFormMainInfoComponent from './AuditFormMainInfoComponent';

export default AuditFormMainInfoComponent;
